import { render, staticRenderFns } from "./EditBoxToggle.vue?vue&type=template&id=1634d3a3&scoped=true&lang=pug&"
import script from "./EditBoxToggle.vue?vue&type=script&lang=ts&"
export * from "./EditBoxToggle.vue?vue&type=script&lang=ts&"
import style0 from "./EditBoxToggle.vue?vue&type=style&index=0&id=1634d3a3&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1634d3a3",
  null
  
)

export default component.exports